import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {FeatureService} from './feature.service';

@NgModule({
  imports: [
    CommonModule,
    RouterModule
  ],
  providers: [
    FeatureService
  ]
})
export class FeatureRoutesModule { }
